<!-- <div id="unity-container" class="unity-desktop"> -->  
<div id="unity-container">

  @if (isLoading()) {
    <div class="unity-header-logo" aria-hidden="true">
      <img class="unity-header-logo-dark" src="assets/images/logo.png" alt="Company logo" />
      <img class="unity-header-logo-light" src="assets/images/logo-light.png" alt="Company logo" />
    </div>
  }
  
  <div id="unity-overlay-container">
    <div id="unity-canvas-placeholder" tabindex="-1">
                  
      @if (isLoading()) {
                        
        <div class="unity-progress-center" style="border: 1px solid black; border-radius: 0.25rem; padding: 1rem; background-color: white; text-align: center; max-width: 40rem; margin: 0 auto;">

          <h1 class="u-margin-b-4">Please wait...</h1>
          <p class="u-margin-b-5 u-text-muted" style="max-width: 40rem; text-justify: center; margin: 0 auto;">
            Loading            
          </p>

          <progressbar
            [value]="loadingProgress()"
            [max]="90"
            [animate]="true"
            [striped]="true"
            style="margin-top: 10px">            
          </progressbar>
        </div>
      }
    </div>
  </div>
    
  

  <div id="unity-warning"> </div>
  <div id="unity-footer">
    <div id="unity-webgl-logo" style="visibility: hidden;"></div>
    <div id="unity-fullscreen-button"></div>
    <div id="unity-build-title" style="visibility: hidden;"></div>
  </div>
</div>